import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";

import "./WSGRModal.scss";

const WSGRModal = ({ open, onClose, onExit }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (
        (event.keyCode === 27 ||
          event.which === 27 ||
          event.key === "Escape") &&
        open
      ) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscKey, true);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey, true);
    };
  }, [open, onClose]);

  return (
    <Modal open={open}>
      <div className="ws-gr-modal">
        <div className="ws-gr-modal-title">Are you sure you want to leave?</div>
        <div className="ws-gr-modal-info">Changes made will not be saved.</div>
        <div className="ws-gr-modal-buttons">
          <Button
            className="ws-gr-modal-stay-button"
            variant="outlined"
            onClick={onClose}
          >
            Remain on Guided Rebalancing
          </Button>
          <Button className="ws-gr-modal-exit-button" onClick={onExit}>
            Exit
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WSGRModal;
